export type Environment = 'ui' | 'pdf';

export const defaultEnvironment = 'ui';
